import { locationIdFormat, productIdFormat } from "@redotech/redo-model/ids";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const LocationInventorySchema = z.object({
  id: locationIdFormat.schema,
  name: z.string(),
  quantity: z.bigint(),
  committed: z.bigint(),
  reserved: z.bigint(),
  available: z.bigint(),
});

export type LocationInventoryData = z.infer<typeof LocationInventorySchema>;

const RedoProductDataSchema = z.object({
  id: productIdFormat.schema,
  title: z.string(),
  vendor: z.string().nullish(),
  price: z.number().nullish(),
  currency: z.string().nullish(),
  sku: z.string().nullish(),
  upc: z.string().nullish(),
  barcodes: z.array(z.string()),
  source: z.string().nullish(),
  source_id: z.string().nullish(),
  image: z.object({ altText: z.string(), url: z.string() }).nullish(),
  locations: z.array(LocationInventorySchema),
  stockout_date: z.instanceof(Temporal.PlainDate).nullish(),
});

export type RedoProductData = z.infer<typeof RedoProductDataSchema>;

export const getRedoProduct = unaryRpc({
  name: "getRedoProduct",
  input: z.object({ productId: productIdFormat.schema }),
  output: RedoProductDataSchema,
});
